module.exports = __webpack_public_path__ + "img/drag.f293c0df.png";